export const FINANCING_OPTIONS_PATH = "/financingoptions" as const;

export const FINANCING_OPTIONS_META = {
  title: "Payment Options | CRS Energy",
  description:
    "Two ways to pay for work with CRS Energy. See how each option works and choose the route that suits your home.",
} as const;

export const FINANCING_OPTIONS_INTRO = {
  h1: "Payment Options",
  sub: "There are two ways to pay for work with CRS Energy. Take a look at both and choose the route that suits you.",
} as const;

export const FINANCING_OPTIONS_CARDS = [
  {
    name: "Ideal4Finance",
    summary:
      "Apply for finance through our finance partner Ideal4Finance to spread the cost of your work.",
    bullets: [
      "Apply directly with Ideal4Finance, subject to status",
      "Choose a repayment term that suits you",
      "Full agreement and terms shown before you sign",
    ],
    ctaLabel: "Find out more",
    href: "/financing-i4f-how-it-works",
  },
  {
    name: "Hometree Finance Solar Plan",
    summary:
      "Lease your solar system through Hometree Finance's Solar Plan, with monitoring, maintenance and repairs included for the life of the plan.",
    bullets: [
      "A lease, not a loan, subject to status",
      "Plan terms from 5 to 25 years",
      "Payments only start once your system is installed",
    ],
    ctaLabel: "Find Out More",
    href: "/financing-solar-lease-plan",
  },
] as const;
